import script from "./ForgotPasswordSetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordSetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordSetPassword.vue?vue&type=style&index=0&id=57fc656d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57fc656d"]])

export default __exports__